export default __webpack_public_path__ + "static/pragicts-our-perspectives-look-beyond-the-marketning-hype-347d9a30a960c8ede384a082f3e90184.jpg";